(function () {
  if (document.__GLOBAL_CART_FIX_V4__) return;
  document.__GLOBAL_CART_FIX_V4__ = true;

  function readQty(lineItem) {
    var node = lineItem.querySelector('[data-qty]');
    if (!node) return 0;

    if (typeof node.value !== 'undefined' && node.value !== null && node.value !== '') {
      var v = parseInt(node.value, 10);
      return Number.isFinite(v) ? v : 0;
    }

    var t = parseInt((node.textContent || '').trim(), 10);
    return Number.isFinite(t) ? t : 0;
  }

  function changeLine(lineId, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-store'
      },
      cache: 'no-store',
      body: JSON.stringify({ id: lineId, quantity: Number(qty) })
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t || ('HTTP ' + r.status)); });
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js?ts=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-store' },
      cache: 'no-store'
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t || ('HTTP ' + r.status)); });
      return r.json();
    });
  }

  function updateHeaderCount(cart) {
    document.querySelectorAll(
      '[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span, .cart-count, .header__cart-count'
    ).forEach(function (el) { el.textContent = cart.item_count; });

    document.querySelectorAll('[data-cart-drawer] [data-item-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  // Minimal drawer refresh (doesn't touch header/close wrapper)
  function softRefreshDrawerParts() {
    var url = '/cart?section_id=cart-drawer&ts=' + Date.now();

    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Cache-Control': 'no-store' },
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t || ('HTTP ' + res.status)); });
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (!newDrawer) return;

        var newList = newDrawer.querySelector('[data-list]');
        var newSubtotal = newDrawer.querySelector('[data-subtotal]');
        var newTotal = newDrawer.querySelector('[data-total]');
        var newShipping = newDrawer.querySelector('[data-shipping-price]');
        var newItemCount = newDrawer.querySelector('[data-item-count]');

        var newListBlock = newDrawer.querySelector('.cart-drawer__list');
        var newIsEmpty = newListBlock && (newListBlock.className || '').indexOf('empty') > -1;

        document.querySelectorAll('[data-cart-drawer]').forEach(function (curDrawer) {
          // header count inside drawer
          if (newItemCount) {
            var curItemCount = curDrawer.querySelector('[data-item-count]');
            if (curItemCount) curItemCount.textContent = newItemCount.textContent;
          }

          // list items
          if (newList) {
            var curList = curDrawer.querySelector('[data-list]');
            if (curList) curList.innerHTML = newList.innerHTML;
          }

          // empty class
          var curListBlock = curDrawer.querySelector('.cart-drawer__list');
          if (curListBlock) {
            if (newIsEmpty) curListBlock.classList.add('empty');
            else curListBlock.classList.remove('empty');
          }

          // totals text
          if (newSubtotal) {
            var curSubtotal = curDrawer.querySelector('[data-subtotal]');
            if (curSubtotal) curSubtotal.textContent = newSubtotal.textContent;
          }
          if (newTotal) {
            var curTotal = curDrawer.querySelector('[data-total]');
            if (curTotal) curTotal.textContent = newTotal.textContent;
          }
          if (newShipping) {
            var curShipping = curDrawer.querySelector('[data-shipping-price]');
            if (curShipping) curShipping.textContent = newShipping.textContent;
          }

          // show/hide blocks (only hidden class)
          var infos = Array.prototype.slice.call(curDrawer.querySelectorAll('[data-cart-info]'));
          infos.forEach(function (n) {
            if (newIsEmpty) n.classList.add('hidden');
            else n.classList.remove('hidden');
          });
        });

        // If drawer.js exposes it globally, rebind (harmless if not)
        if (typeof window.attachCartEventListeners === 'function') {
          window.attachCartEventListeners();
        }
      });
  }

  // ✅ NEW: whenever drawer opens, refresh it once so qty never "dies" on other pages
  function handleDrawerOpenRefresh(e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (!toggle) return;

    // allow theme to open drawer first, then refresh content
    setTimeout(function () {
      softRefreshDrawerParts()
        .then(function () { return getCart(); })
        .then(function (cart) { updateHeaderCount(cart); })
        .catch(function (err) { console.error('Drawer open refresh error:', err); });
    }, 50);
  }

  // Listen globally for drawer open clicks
  document.addEventListener('click', handleDrawerOpenRefresh, true);

  // ✅ Capture handler for + / - / remove (always works)
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-plus]');
    var minus = e.target.closest('[data-minus]');
    var rem = e.target.closest('[data-remove]');
    if (!plus && !minus && !rem) return;

    var drawer = e.target.closest('[data-cart-drawer]');
    if (!drawer) return;

    var btn = plus || minus || rem;
    var lineItem = btn.closest('[data-component="lineItem"]');
    if (!lineItem) return;

    var lineId = lineItem.getAttribute('data-id');
    if (!lineId) return;

    // We handle it → block theme handlers
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var newQty;

    if (rem) {
      newQty = 0;
    } else {
      var currentQty = readQty(lineItem);
      if (!Number.isFinite(currentQty) || currentQty < 0) currentQty = 0;

      if (minus && currentQty <= 1) return;
      newQty = currentQty + (plus ? 1 : -1);
      if (plus && newQty < 1) newQty = 1;
    }

    changeLine(lineId, newQty)
      .then(function () { return softRefreshDrawerParts(); })
      .then(function () { return getCart(); })
      .then(function (cart) { updateHeaderCount(cart); })
      .catch(function (err) { console.error('Global cart fix v4 error:', err); });
  }, true);

})();
